import { Component, inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';
import { Catalog } from '@cureskin/api-client/src/server-api';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'teenager-restriction-bottomsheet',
  imports: [ButtonCtaComponent],
  templateUrl: './teenager-restriction-bottomsheet.component.html',
})
export class TeenagerRestrictionBottomsheetComponent implements OnInit {
  private readonly eventLoggerService = inject(EventLoggerService);
  bottomSheetRef: MatBottomSheetRef<TeenagerRestrictionBottomsheetComponent> = inject(MatBottomSheetRef<TeenagerRestrictionBottomsheetComponent>);
  public readonly data: { product: Catalog } = inject(MAT_BOTTOM_SHEET_DATA);
  
  productImage: string | null = null;

  ngOnInit(): void {
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({
      name: 'add_to_cart_teenager_bs',
    }));
    this.productImage = this.getProductImage(this.data.product);
  }

  getProductImage(product: Catalog): string | null {
    return product?.rebrandedImageWithBackground?.at(-1)
    ?? product?.productUnboxedImage?.at(-1)
    ?? null;
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }
}
